import { Navigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useAppContext } from "../../Context/AppContext";
import { useGetUser } from "../../api/queries/useGetUser";
import { isBusinessOrExecutiveMembership } from "../../utils/membershipTier";

type MuslimInvestRouteProps = {
  children: React.ReactNode;
};

export default function MuslimInvestRoute({ children }: MuslimInvestRouteProps) {
  const { objectId } = useAppContext();
  const { data: userData, isPending, isFetching } = useGetUser({
    id: objectId || "",
    enabled: !!objectId,
  });

  if (!objectId || isPending || isFetching || !userData?.user) {
    return (
      <div className="container p-4 text-center">
        <Spinner animation="border" variant="primary" role="status">
          <span className="visually-hidden">Loading</span>
        </Spinner>
      </div>
    );
  }

  if (!isBusinessOrExecutiveMembership(userData.user.membershipName)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
